import React, { useState } from "react";
import returnPolicyImage from "../../images/return-policy.jpg";
import "./ReturnPolicy.css";

const ReturnPolicy = () => {
  const [openFAQ, setOpenFAQ] = useState(0); // First FAQ is open by default

  const faqData = [
    {
      question: "I received a part that looks to be damaged. What should I do?",
      answer:
        "In a scenario where you receive a part, and dry test it out to find that the part is damaged, please contact us right away and send us images or videos if possible so we can have the records on file.",
    },
    {
      question: "What does Dry Test mean?",
      answer:
        "Dry test means testing the part without installing it in the device to check if it functions properly before installation.",
    },
    {
      question: "What does Internal Damage mean on display assemblies?",
      answer:
        "Internal damage refers to any damage that occurs inside the display assembly, such as cracked LCD, damaged digitizer, or broken internal components that are not visible from the outside.",
    },
    {
      question: "How long will it take to process my return?",
      answer:
        "Return processing typically takes 3-5 business days once we receive your returned item. You will receive an email notification once the processing is complete.",
    },
    {
      question: "Can I send multiple returns at the same time?",
      answer:
        "Yes, you can send multiple returns in the same package. Please ensure each item is properly labeled and include all necessary documentation for each return.",
    },
    {
      question:
        "Do I need to wait for an authorization before shipping my returns?",
      answer:
        "Yes, you must receive return authorization before shipping your returns. Please contact our support team to initiate the return process and receive your return authorization number.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  return (
    <div className="return-policy-container">
      <h1 className="return-policy-main-title">
        Return, Exchange & Refund Policy​
      </h1>

      <div className="return-policy-image-section">
        <img
          src={returnPolicyImage}
          alt="Return Policy"
          className="return-policy-image"
        />
        <div className="return-policy-image-text">Warranty​ Policy</div>
      </div>

      <div className="warranty-policy-text-section">
        <h2 className="warranty-policy-subtitle">Warranty​ Policy</h2>
        <p className="warranty-policy-description">
          At Wireox LLC, we aim to ensure a smooth and fair return process.
          Please review the following policy carefully:
        </p>
      </div>

      <div className="other-sections-container">
        <div className="warranty-separator"></div>

        <div className="warranty-section">
          <h3 className="warranty-section-title">
            Return Authorization (Email Required):
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>All returns must be authorized in advance.</li>
            <li>
              Customers are required to submit a return request by emailing{" "}
              <a href="mailto:returns@wireox.com">returns@wireox.com</a> before
              sending any item back.
            </li>
            <li>
              Return shipments sent without prior email authorization may be
              refused.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Return Evaluation Process
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Once the returned item is received, it will undergo a final
              inspection by the Wireox RMA department.
            </li>
            <li>
              All return claims are subject to approval based on this
              evaluation.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Defective Items
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Items confirmed to be defective will be replaced with the same or
              similar product only.
            </li>
            <li>No cash refunds will be issued for defective items.</li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Warranty Coverage
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Products are covered under a 30-day limited warranty from the
              invoice date.
            </li>
            <li>
              The warranty covers defects in material and workmanship only.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Warranty Exclusions
          </h3>
          <p className="warranty-section-text warranty-section-lead">
            The warranty will be void if:
          </p>
          <ul className="warranty-section-text warranty-section-list">
            <li>Payment for the item has not been made as agreed.</li>
            <li>
              The item was sold &quot;AS-IS&quot; or covered under a different
              warranty.
            </li>
            <li>
              The product shows signs of:
              <ul className="warranty-section-list-nested">
                <li>Abuse or misuse</li>
                <li>Alteration or neglect</li>
                <li>Damage during shipping</li>
                <li>Expiration of the warranty period</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Non-Returnable Items
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Items sold AS-IS are final sale and not eligible for return or
              replacement.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Shipping &amp; Restocking Fees
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Customers are responsible for all return shipping costs unless
              otherwise agreed.
            </li>
            <li>
              A 20% restocking fee will apply to returned shipments due to:
              <ul className="warranty-section-list-nested">
                <li>Refused delivery</li>
                <li>Incorrect address</li>
                <li>Business closure</li>
                <li>COD issues (e.g., payment not ready)</li>
                <li>Hold for pickup or delayed acceptance</li>
              </ul>
            </li>
            <li>
              Customers must also cover both outbound and return shipping
              charges in such cases.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Refund Policy
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Refunds are not guaranteed and are issued only if approved after
              inspection.
            </li>
            <li>
              Approved refunds will not exceed the original invoice amount.
            </li>
          </ul>
        </div>

        <div className="warranty-section">
          <h3 className="warranty-section-title warranty-section-title--sm">
            Important Notes
          </h3>
          <ul className="warranty-section-text warranty-section-list">
            <li>
              Shipping, handling, and related service fees are non-refundable.
            </li>
            <li>
              Wireox LLC reserves the right to deny any return that does not
              meet the above conditions.
            </li>
          </ul>
        </div>
        <div className="faq-section">
          <h2 className="faq-title">FREQUENTLY ASKED QUESTION (FAQ'S)</h2>

          <div className="faq-container">
            {faqData.map((faq, index) => (
              <div key={index} className="faq-item">
                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                  <span className="faq-question-text">{faq.question}</span>
                  <span
                    className={`faq-chevron ${openFAQ === index ? "open" : ""}`}
                  >
                    ▼
                  </span>
                </div>
                {openFAQ === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
